export interface GetUsageStatisticsRequest {
  targetDate: string
}

export function GetUsageStatisticsRequestToJSON(
  value: GetUsageStatisticsRequest
): any {
  return {
    target_date: value.targetDate !== '' ? value.targetDate : undefined
  }
}
